// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)
